/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Islands Fabric buy-box trust list (added Oct 28, 2026). Shows under Add to cart on every product page. */
(function () {
  function addTrust() {
    if (!document.body.classList.contains('template-product') && !/\/products\//.test(location.pathname)) return;
    var box = document.querySelector('.product-form__payment-container');
    if (!box || document.querySelector('.if-trust')) return;
    var ul = document.createElement('ul');
    ul.className = 'if-trust';
    ul.innerHTML =
      '<li><span>&#10003;</span> No minimum order &middot; buy just what you need</li>' +
      '<li><span>&#10003;</span> Ships from Los Angeles with tracking, usually in 1-3 business days</li>' +
      '<li><span>&#10003;</span> Colors can vary by screen: questions? Call <a href="tel:+12136224454">213-622-4454</a></li>';
    var css = document.createElement('style');
    css.textContent = '.if-trust{list-style:none;margin:14px 0 0;padding:12px 14px;border:1px solid #e1e3e4;border-radius:6px;background:#fff;font-size:14px;line-height:1.5}' +
      '.if-trust li{margin:2px 0}.if-trust span{color:#156915;font-weight:700;margin-right:6px}.if-trust a{text-decoration:underline}';
    document.head.appendChild(css);
    box.parentNode.insertBefore(ul, box.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addTrust); else addTrust();
})();
